import { Link, useParams } from "react-router-dom";

const ENTITY = "[Legal entity name]";
const ADDRESS = "[Registered address]";
const EMAIL = "[support@dicta.si]";
const DAYS = "[7]";

const PAGES = {
  refunds: {
    title: "Cancellation & Refunds",
    body: [
      ["Cancelling", "You can cancel anytime by replying CANCEL PLAN to Dicta on WhatsApp. Auto-renewal stops, and your plan stays on until the end of the period you have already paid for. After that you move to the Free plan. Your saved files are kept."],
      ["Refunds", "Payments already made are not refunded. This includes partly used periods and one-time payments."],
      ["Technical errors", `If you are charged twice, or charged the wrong amount because of a technical error, we refund the extra amount in full within ${DAYS} working days after you contact us at ${EMAIL}. Refunds go back to the original payment method.`],
      ["Failed renewals", "If a renewal payment fails, Razorpay retries it once a day for 3 days and your plan stays on meanwhile. If every retry fails, you move to the Free plan. Nothing is charged after that."],
    ],
  },
  terms: {
    title: "Pricing & Terms",
    body: [
      ["Plans and prices (taxes included)", "Pro: ₹1,500 per month or ₹15,000 per year. Elite: ₹5,000 per month or ₹50,000 per year. One-time payment: one month of Pro for ₹1,500 or of Elite for ₹5,000, with no auto-debit."],
      ["What each plan includes", "Free: 20 case lookups and 3 document reads a month, 3 hearing alerts, 1 GB of saved files. Pro: 100 case lookups and 50 document reads a month, 25 hearing alerts, legal research, 10 GB of saved files. Elite: unlimited case lookups, document reads and hearing alerts, more legal research, 50 GB of saved files."],
      ["Auto-renewal", "Monthly and yearly plans renew automatically through a UPI AutoPay or card mandate that you approve on Razorpay's page. Each renewal is charged at the start of the new period. Reply CANCEL PLAN to stop renewal at the end of the paid period."],
      ["One-time payments", "A one-time payment covers one month. On the same plan it adds one month to your current end date. It can't be combined with a different plan that is still running."],
      ["Renewal failure", "If a renewal charge fails, your plan stays on while Razorpay retries once a day for 3 days, and Dicta sends you two reminders. If all retries fail, you move to the Free plan. Your files are kept, but new files are saved only while your storage is within the Free limit."],
      ["Receipts", "Razorpay sends the payment receipt by email or SMS. Dicta does not issue GST invoices at this time."],
    ],
  },
  contact: {
    title: "Contact",
    body: [
      ["Support", `Email ${EMAIL}, or message Dicta on WhatsApp.`],
      ["Business details", `${ENTITY}, ${ADDRESS}.`],
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const p = PAGES[page] || PAGES.terms;
  return (
    <div className="min-h-screen bg-[--w-bg] text-[--w-text-2]" data-testid={`legal-page-${page}`}>
      <div className="mx-auto max-w-2xl px-5 py-12">
        <p className="text-xs uppercase tracking-[0.2em] text-[--w-text-3]">Dicta</p>
        <h1 data-testid="legal-title" className="mt-2 font-display text-4xl font-bold text-[--w-text] sm:text-5xl">{p.title}</h1>
        <div className="mt-10 space-y-8">
          {p.body.map(([h, t]) => (
            <section key={h}>
              <h2 className="text-base font-semibold text-[--w-text] md:text-lg">{h}</h2>
              <p className="mt-2 text-sm leading-relaxed sm:text-base">{t}</p>
            </section>
          ))}
        </div>
        <nav className="mt-14 flex flex-wrap gap-5 border-t border-[--w-border] pt-6 text-sm">
          {Object.entries(PAGES).map(([k, v]) => (
            <Link key={k} to={`/legal/${k}`} data-testid={`legal-link-${k}`} className="text-[--w-text-2] transition-colors duration-200 hover:text-[--w-text]">{v.title}</Link>
          ))}
        </nav>
      </div>
    </div>
  );
}
